'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconEyeDash, iconEyeDashTag } from '@ni/nimble-components/dist/esm/icons/eye-dash';
import { wrap } from '../../utilities/react-wrapper';

export type { IconEyeDash };
export { iconEyeDashTag };
export const NimbleIconEyeDash = wrap(IconEyeDash);